import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "previousLink",
    "currentStep",
    "stepContent",
    "requiredText",
    "geographicStateInput",
    "timeUntilSchoolInput",
    "childAgeInput",
    "stepText",
    "njSection",
  ]

  connect() {
    this.requiredTextTargets.forEach((text) => (text.style.display = "none"))
    this.showStateSections()
    this.stepHistory = [1]
    this.goToStep(1)
  }

  nextStep(event) {
    // console.log("next step")
    event?.preventDefault()
    const numSteps = this.stepContentTargets.length

    if (this.currentStep >= numSteps) {
      this.submitQuestionnaire()
    } else {
      this.stepHistory.push(this.currentStep + 1)
      this.goToStep(this.currentStep + 1)
    }
  }

  prevStep(event) {
    // console.log("prev step", this.stepHistory)
    this.stepHistory.pop()
    event?.preventDefault()
    this.goToStep(this.stepHistory[this.stepHistory.length - 1])
  }

  goToStepWithKey(stepKey) {
    // console.log("go to step with key", stepKey)
    const index = this.stepContentTargets.findIndex(
      (element) => element.dataset.stepKey === stepKey,
    )
    if (index >= 0) {
      this.stepHistory.push(index + 1)
      this.goToStep(index + 1)
    }
  }

  goToStep(step) {
    // console.log("go to step ", step)
    this.currentStep = step

    if (this.hasCurrentStepTarget) {
      this.currentStepTarget.textContent = `Step ${this.currentStep}`
    }
    this.togglePreviousLink()

    this.stepContentTargets.forEach((element, index) => {
      const isStep = this.currentStep === index + 1
      const display = isStep ? "block" : "none"
      element.style.display = display

      if (isStep) {
        this.stepTextTarget.innerText = element.dataset.stepText || ""
      }
    })

    window.scrollTo(0, 0)
  }

  togglePreviousLink() {
    const display = this.stepHistory.length > 1 ? "flex" : "none"
    this.previousLinkTarget.style.display = display
  }

  validate(event) {
    event.preventDefault()
    const stepContent = this.stepContentTargets.find((target) =>
      target.contains(event.target),
    )

    let valid = true
    stepContent.querySelectorAll("input, select").forEach((control) => {
      if (!control.validity.valid) {
        control.classList.add("is-invalid")
        valid = false
      } else {
        control.classList.remove("is-invalid")
      }
    })

    const radioButton = stepContent.querySelector("input[type='radio']")
    if (this.isVisible(radioButton)) {
      const selectedValue = stepContent.querySelector(
        "input[type='radio']:checked",
      )?.value
      const requiredText = this.requiredTextTargets.find((text) =>
        stepContent.contains(text),
      )

      if (selectedValue?.length > 0) {
        requiredText.style.display = "none"
      } else {
        valid = false
        requiredText.style.display = "block"
      }
    }

    if (valid) {
      this.nextStep()
    }
  }

  isVisible(el) {
    return !!el && el.offsetParent !== null
  }

  validateSavingFor(event) {
    event.preventDefault()

    const stepContent = this.stepContentTargets.find((target) =>
      target.contains(event.target),
    )
    const requiredText = this.requiredTextTargets.find((text) =>
      stepContent.contains(text),
    )

    const selectedValue = stepContent.querySelector(
      "input[type='radio']:checked",
    )?.value

    let valid = true
    if (selectedValue?.length > 0) {
      requiredText.style.display = "none"
    } else {
      valid = false
      requiredText.style.display = "block"
    }

    this.timeUntilSchoolInputTarget.classList.remove("is-invalid")
    this.childAgeInputTarget.classList.remove("is-invalid")
    switch (selectedValue) {
      case "myself":
        const timeUntilSchool = this.timeUntilSchoolInputTarget.value
        if (timeUntilSchool.length <= 0 || timeUntilSchool < 0) {
          valid = false
          this.timeUntilSchoolInputTarget.classList.add("is-invalid")
        }
        break
      case "existing_child":
        const childAge = this.childAgeInputTarget.value
        console.log("childAge", childAge)
        if (childAge.length <= 0 || childAge < 0) {
          valid = false
          this.childAgeInputTarget.classList.add("is-invalid")
        }
        break
    }

    if (valid) {
      this.nextStep()
    }
  }

  validateRadio(event) {
    event.preventDefault()

    const stepContent = this.stepContentTargets.find((target) =>
      target.contains(event.target),
    )
    const requiredText = this.requiredTextTargets.find((text) =>
      stepContent.contains(text),
    )

    const selectedValue = stepContent.querySelector(
      "input[type='radio']:checked",
    )?.value

    let valid = true
    if (selectedValue?.length > 0) {
      requiredText.style.display = "none"
    } else {
      valid = false
      requiredText.style.display = "block"
    }

    if (valid) {
      this.nextStep()
    }
  }

  getStepByKey(stepKey) {
    return this.stepContentTargets.find(
      (element) => element.dataset.stepKey === stepKey,
    )
  }

  getRadioValue(stepContent) {
    return stepContent.querySelector("input[type='radio']:checked")?.value
  }

  validateInvestmentApproach(event) {
    event.preventDefault()

    const stepContent = this.stepContentTargets.find((target) =>
      target.contains(event.target),
    )
    const requiredText = this.requiredTextTargets.find((text) =>
      stepContent.contains(text),
    )

    const selectedValue = stepContent.querySelector(
      "input[type='radio']:checked",
    )?.value

    let valid = true
    if (selectedValue?.length > 0) {
      requiredText.style.display = "none"
    } else {
      valid = false
      requiredText.style.display = "block"
    }

    if (valid) {
      switch (selectedValue) {
        case "not_sure":
          this.nextStep()
          break
        default:
          this.submitQuestionnaire()
      }
    }
  }

  showStateSections() {
    const selectedState =
      this.geographicStateInputTarget.options[
        this.geographicStateInputTarget.selectedIndex
      ].text

    const display = selectedState.startsWith("New Jersey") ? "block" : "none"

    this.njSectionTargets.forEach((element, index) => {
      element.style.display = display
    })
  }

  submitQuestionnaire(event) {
    // const data = new FormData(this.element);
    // console.log("submitting", data)
    this.element.submit()
  }
}
